import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './entradaForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, setFiltro, salvar, carregar, descarregar, chegada, desfazer, excluir, 
	getLista, getListaProduto, getListaUnidade, getListaVeiculo, 
	getListaMotorista, getListaDistribuidora, getListaTanque,
	getListaPedido
} from './entradaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import EntradaBaseVisualizacao from './entradaBaseVisualizacao';
import Select from '../common/form/select';

class Entrada extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaProduto();
		this.props.getListaUnidade();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
		this.props.getListaDistribuidora();
		this.props.getListaTanque();
		this.props.getListaPedido();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaProduto();
			this.props.getListaUnidade();
			this.props.getListaVeiculo();
			this.props.getListaMotorista();
			this.props.getListaDistribuidora();
			this.props.getListaTanque();
			this.props.getListaPedido();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {

		const lista = this.filtrar();

        return (
            <div>
                <Content>

					{this.modalBaseVisualizacao()}

					{this.props.listaVeiculo.filter(item => item.documentacao_vencida).length > 0 && 
					<Row alignCenter>
						{this.props.listaVeiculo.filter(item => 
							item.documentacao_vencida
							&& lista.filter(pedido => pedido.id_veiculo == item.id).length
						).map(item => (
							<div key={item.id}
								style={{
									backgroundColor: '#de0000',
									color: '#ffffff', 
									margin: 4,
									paddingLeft: 12,
									paddingTop: 4,
									paddingRight: 12,
									paddingBottom: 4,
									borderRadius: 4,
									textAlign: 'center'
								}}>
								<div>
									<i class="icon fas fa-ban"></i> Problemas na documentação!
								</div>
								<div style={{ fontWeight: 'bold' }}>
									{item.valor}
								</div>
							</div>
						))}
					</Row>}

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		return this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome_tipo} ${item.nome_unidade || ''} ${item.nome_distribuidora || ''} ${item.nome_motorista || ''} ${item.numero_nfe || ''} ${item.placa_veiculo || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			if (this.props.filtro.data_inicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_programacao)) < DateFormat.formatarDataTelaParaSql(this.props.filtro.data_inicial)) {
				return false;
			}
			if (this.props.filtro.data_final
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_programacao)) > DateFormat.formatarDataTelaParaSql(this.props.filtro.data_final)) {
				return false;
			}
			return true;
		}).filter(item => {
			if ((this.props.filtro.ids_unidades || []).length && !(this.props.filtro.ids_unidades || []).includes(item.id_unidade)) {
				return false;
			}
			if ((this.props.filtro.ids_distribuidoras || []).length && !(this.props.filtro.ids_distribuidoras || []).includes(item.id_distribuidora)) {
				return false;
			}
			if ((this.props.filtro.ids_motoristas || []).length && !(this.props.filtro.ids_motoristas || []).includes(item.id_motorista)) {
				return false;
			}
			if ((this.props.filtro.ids_veiculos || []).length && !(this.props.filtro.ids_veiculos || []).includes(item.id_veiculo)) {
				return false;
			}

			return true;
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const lista = this.filtrar();

		let listaExportacao = [];
		lista.forEach(item => {
			(item.itens || []).forEach(entradaItem => {
				listaExportacao.push({
					...item,
					id: `${item.id}-${entradaItem.id}`,					
					datahora_programacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_programacao),
					datahora_carga: item.datahora_carga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga) : null,
					datahora_previsao_chegada: item.datahora_previsao_chegada ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada) : null,
					datahora_descarga: item.datahora_descarga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga) : null,
					nome_produto: entradaItem.nome_produto,
					quantidade: FormatUtils.formatarValorTela(entradaItem.quantidade, 2),
					preco: FormatUtils.formatarValorTela(entradaItem.preco, 4)
				});
			});
		});
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										entrada: true, 
										ponto_atendimento: false, 
										vendedor: false, 
										datahora_previsao_chegada: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()) 
									});
								}} />
						</Grid>
						<Grid cols='6 6 3 2'>
							<ExcelFile
								filename={'Entradas'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={listaExportacao.map(item => ({
									...item,
								}))} name='Entradas'>
									<ExcelColumn label='Data Hora' value='datahora_programacao' />
									<ExcelColumn label='Tipo' value='nome_tipo' />
									<ExcelColumn label='Unidade' value='nome_unidade' />
									<ExcelColumn label='Distribuidora' value='nome_distribuidora' />
									<ExcelColumn label='Produto' value='nome_produto' />
									<ExcelColumn label='Quantidade' value='quantidade' />
									<ExcelColumn label='Preço' value='preco' />
									<ExcelColumn label='Motorista' value='nome_motorista' />
									<ExcelColumn label='Veículo' value='placa_veiculo' />
									<ExcelColumn label='Número da Nota' value='numero_nfe' />
									<ExcelColumn label='Carga' value='datahora_carga' />
									<ExcelColumn label='Previsão Descarga' value='datahora_previsao_chegada' />
									<ExcelColumn label='Chegada na Base' value='datahora_chegada' />
									<ExcelColumn label='Descarga' value='datahora_descarga' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_inicial}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_final}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaUnidade.filter(item => (this.props.filtro.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_unidades: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaDistribuidora}
							label='Distribuidora'
							cols='12 6 3 3'
							maxWidth={300}
							placeholder='Selecione'
							multiple
							value={this.props.listaDistribuidora.filter(item => (this.props.filtro.ids_distribuidoras || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_distribuidoras: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaMotorista}
							label='Motorista'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaMotorista.filter(item => (this.props.filtro.ids_motoristas || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_motoristas: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							maxWidth={220}
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.props.filtro.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_veiculos: (values || []).map(item => item.value) });
							}} />
					</Row>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Data Hora</Th>
								<Th colspan={1}>Tipo</Th>
								<Th colspan={1}>Unidade</Th>
								<Th colspan={1}>Distribuidora</Th>
								<Th colspan={1}>Motorista</Th>
								<Th colspan={1}>Veículo</Th>
								<Th colspan={1} alignCenter>Número da Nota</Th>
								<Th colspan={1} alignCenter>S10</Th>
								<Th colspan={1} alignCenter>S500</Th>
								<Th colspan={1} alignCenter>Carga</Th>
								<Th colspan={1} alignCenter>Previsão Descarga</Th>
								<Th colspan={1} alignCenter>Chegada na Base</Th>
								<Th colspan={1} alignCenter>Descarga</Th>
								<Th colspan={1} alignCenter>Meta/Realizado</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								let qtdS10 = 0;
								let qtdS500 = 0;
								(item.itens || []).filter(produto => produto).map(produto => {
									if (produto.id_produto == 1) {
										qtdS10 += parseFloat(produto.quantidade || 0);
									} else if (produto.id_produto == 3) {
										qtdS500 += parseFloat(produto.quantidade || 0);
									}
								});

								return (
									<Tr key={item.id} 
										className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onMouseEnter={() => this.setState({ linhaSelecionada: item.id })} >
										<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_programacao)}</Td>
										<Td>{item.nome_tipo}</Td>
										<Td>{item.nome_unidade}</Td>
										<Td>{item.nome_distribuidora}</Td>
										<Td>{item.nome_motorista}</Td>
										<Td>{item.placa_veiculo}</Td>
										<Td alignCenter>{item.numero_nfe}</Td>
										<Td alignCenter>{qtdS10 ? FormatUtils.formatarValorTelaDecimal(qtdS10) : '-'}</Td>
										<Td alignCenter>{qtdS500 ? FormatUtils.formatarValorTelaDecimal(qtdS500) : '-'}</Td>
										<Td alignCenter>{item.datahora_carga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga) : (
											<ButtonTable
												type={'success'}
												icon={'fas fa-check'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.carregar(item);
												}} />
										)}</Td>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada)}</Td>
										<Td alignCenter>{
											item.datahora_chegada ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada) 
											: (item.datahora_carga ? (
												<ButtonTable
													type={'success'}
													icon={'fas fa-check'}
													visible={this.state.linhaSelecionada == item.id}
													event={() => {
														this.props.chegada(item);
													}} />
											) : null)}
										</Td>
										<Td alignCenter>{
											item.datahora_descarga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga) 
											: (item.datahora_carga ? (
												<ButtonTable
													type={'success'}
													icon={'fas fa-check'}
													visible={this.state.linhaSelecionada == item.id}
													event={() => {
														this.props.descarregar(item);
													}} />
											) : null)}
										</Td>
										<Td alignCenter>{parseInt(item.tempo_descarga_meta)}/{parseInt(item.tempo_descarga_realizado)}</Td>
										<Td alignRight minWidth={200}>
											{(item.datahora_carga || item.datahora_chegada || item.datahora_descarga) && 
											<ButtonTable
												type={'danger'}
												icon={'fas fa-undo'}
												visible={this.state.linhaSelecionada == item.id}
												title={item.datahora_descarga ? 'Desfazer descarga' : (item.datahora_chegada ? 'Desfazer chegada na base' : 'Desfazer carga')}
												event={() => {
													if (window.confirm(`Deseja mesmo desfazer a ${item.datahora_descarga ? 'descarga' : (item.datahora_chegada ? 'chegada na base' : 'carga')}?`)) {
														this.props.desfazer(item);
													}
												}} />}

											<ButtonTable
												type={'primary'}
												icon={'fas fa-gas-pump'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.setState({
														modalBaseVisualizacao: {
															...item
														}
													});
												}} />

											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														datahora_previsao_chegada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada),
														itens: (item.itens || []).map(entradaItem => ({
															...entradaItem,
															quantidade: FormatUtils.formatarValorTela(entradaItem.quantidade, 2),
															preco: FormatUtils.formatarValorTela(entradaItem.preco, 4),
															prazo: FormatUtils.formatarValorTela(entradaItem.prazo, 0)
														}))
													});
													this.props.initForm({
														...item,
														datahora_previsao_chegada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada),
														itens: (item.itens || []).map(entradaItem => ({
															...entradaItem,
															quantidade: FormatUtils.formatarValorTela(entradaItem.quantidade, 2),
															preco: FormatUtils.formatarValorTela(entradaItem.preco, 4),
															prazo: FormatUtils.formatarValorTela(entradaItem.prazo, 0)
														}))
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {

													this.props.setModoTela('exclusao', {
														...item,
														datahora_previsao_chegada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada),
														itens: (item.itens || []).map(entradaItem => ({
															...entradaItem,
															quantidade: FormatUtils.formatarValorTela(entradaItem.quantidade, 2),
															preco: FormatUtils.formatarValorTela(entradaItem.preco, 4),
															prazo: FormatUtils.formatarValorTela(entradaItem.prazo, 0)
														}))
													});
													this.props.initForm({
														...item,
														datahora_previsao_chegada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada),
														itens: (item.itens || []).map(entradaItem => ({
															...entradaItem,
															quantidade: FormatUtils.formatarValorTela(entradaItem.quantidade, 2),
															preco: FormatUtils.formatarValorTela(entradaItem.preco, 4),
															prazo: FormatUtils.formatarValorTela(entradaItem.prazo, 0)
														}))
													});
												}} />
										</Td>
									</Tr>
								)
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalBaseVisualizacao() {

		if (!this.state.modalBaseVisualizacao) {
			return null;
		}
		
		const registro = { ...this.state.modalBaseVisualizacao };

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Processo de Descarga na Base</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ modalBaseVisualizacao: null, zoom: 100 })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>

							<EntradaBaseVisualizacao 
								registro={registro}
								eventoAtualizacao={() => {
									this.props.getLista();
									this.setState({ modalBaseVisualizacao: null, zoom: 100 });
								}} />
								
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.entrada,
	modoTela: state.entrada.modoTela,
	filtro: state.entrada.filtro,
	lista: state.entrada.lista,
    listaVeiculo: state.entrada.listaVeiculo,
	listaUnidade: state.entrada.listaUnidade,
	listaDistribuidora: state.entrada.listaDistribuidora,
	listaMotorista: state.entrada.listaMotorista,
	listaVeiculo: state.entrada.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, salvar, carregar, descarregar, chegada, desfazer, excluir, 
	getLista, getListaProduto, getListaUnidade, getListaVeiculo, 
	getListaMotorista, getListaDistribuidora, getListaTanque,
	getListaPedido
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Entrada);
